import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IApiResponse } from '../shared/interface/interface';

const apiUrlV3 = environment.API_BASE_URL_V3;

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    constructor(private http: HttpClient) { }


    /**
     * Searches items
     * @param {string} keyWord - The search keyword
     * @param {string} owner_address - The owner's address
     * @param {number} limit - Number of results to limit per page (default is 10)
     * @param {number} logPage - The page number for logs (default is 1)
     * @param {number} collectionPage - The page number for collections (default is 1)
     * @param {number} nftPage - The page number for NFTs (default is 1)
     * @param {number} userPage - The page number for users (default is 1)
     * @param {number} holdingPage - The page number for holdings (default is 1)
     * @returns {Observable<any>} - The HTTP response from the search API
     */
    public searchItems(
        keyWord: string,
        owner_address: string,
        limit = 10,
        logPage = 1,
        collectionPage = 1,
        nftPage = 1,
        userPage = 1,
        holdingPage = 1
    ): Observable<IApiResponse> {
        return this.http.get<IApiResponse>(`${apiUrlV3}management/search-item`, {
            params: {
                owner_address,
                search: keyWord,
                limit,
                logPage: logPage,
                collectionPage: collectionPage,
                nftPage: nftPage,
                userPage: userPage,
                holdingPage: holdingPage
            }
        });
    }



}
